<template>
  <div id="kApp" class="k-app" :class="{
    'has-tabbar': hasTabbar
  }">
    <k-navbar />
    <router-view />
    <k-tabbar v-if="hasTabbar" :current="idxTabbar" />
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    computed: {
      ...mapState(['hasTabbar', 'idxTabbar'])
    }
  };

</script>
